export const CURRENCY_CONVERTER = '/_api/currency-converter/v1/currencies'
export const CURRENCY_CONVERTER_SETTINGS = '/_api/currency-converter-settings/v1/currencies/site'
